import { render, staticRenderFns } from "./syllabus.vue?vue&type=template&id=41090592&"
import script from "./syllabus.vue?vue&type=script&lang=js&"
export * from "./syllabus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports